import React from 'react';

const proFeatures = [
  'Multi-company management',
  'Expenses: Advances & Salary',
  'Reports: Full Business & Tax suite',
  'Bill Templates: Additional sizes/layouts',
  'Employee Work Assignment (full matrix)',
  'Company MPIN on sensitive actions',
  'Advanced exports'
];

const maxFeatures = [
  'Manufacturing: Full (process, analytics)',
  'Advanced analytics & automations',
  'All GST + Income-tax summaries',
  'Custom templates & themes',
  'Backups/restore advanced & admin tools'
];

export default function Upgrades() {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <h2 className="text-2xl font-bold text-gray-900 mb-4">Upgrades & Features</h2>
      <p className="text-gray-600 mb-6">Unlock more power with Pro and Max plans. Contact support for offline upgrades or visit the pricing page.</p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="border rounded-lg p-4">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Pro Plan</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            {proFeatures.map(f => <li key={f}>• {f}</li>)}
          </ul>
          <a href="/pricing#pro" className="inline-block mt-4 px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">View Pricing</a>
        </div>
        <div className="border rounded-lg p-4">
          <h3 className="text-xl font-semibold text-gray-900 mb-2">Max Plan</h3>
          <ul className="space-y-2 text-sm text-gray-700">
            {maxFeatures.map(f => <li key={f}>• {f}</li>)}
          </ul>
          <a href="/pricing#max" className="inline-block mt-4 px-4 py-2 bg-purple-600 text-white rounded hover:bg-purple-700">View Pricing</a>
        </div>
      </div>
    </div>
  );
}
